const screenSizes = {
    tablet : '375px',
    desktop : '768px'
}

export const mediaQuery = {
    tablet : `@media screen and (min-width: ${screenSizes.tablet})`,
    desktop : `@media screen and (min-width: ${screenSizes.desktop})`
}